import { AddressValidationActions } from '../../container/AddressValidation';
import { ProductAvailability } from '../../container/AddressValidation/interface';
import { ProductType } from '../../enum';
import { CmsAvailabilityButton } from '../../interface';
import { getOptionPageUrl } from '../url';

const getResultText = (cmsProps: CmsAvailabilityButton, availability: ProductAvailability) => {
    if (availability.tvConnect && availability.cableTv) {
        return cmsProps.backToLandingPage;
    }

    if (!availability.tvConnect && availability.cableTv) {
        return cmsProps.continueToOptionPage;
    }

    return cmsProps.goToGigatvNet;
};

const getResultAction = (actions: AddressValidationActions, availability: ProductAvailability) => {
    if (!availability.tvConnect && availability.cableTv) {
        return undefined;
    }

    if (availability.tvConnect && availability.cableTv) {
        return () => actions.setOverlayVisibility(false);
    }

    return () => {
        actions.setSelectedProduct({ type: ProductType.NET });
        actions.setOverlayVisibility(false);
    };
};

const getResultLink = (availability: ProductAvailability, selectedId: string) => {
    if (!availability.tvConnect && availability.cableTv) {
        return getOptionPageUrl(selectedId);
    }

    return undefined;
};

export default {
    getResultText,
    getResultAction,
    getResultLink,
};
